import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import swal from 'sweetalert2';
import { IncidenciasService } from '../../incidencias.service';
import { Incidencias } from 'src/app/shared/model/incidencias/incidencia.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { VersionBean } from 'src/app/shared/model/incidencias/version.model';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { MensajesFijosEnum } from 'src/app/utilerias/enums/mensajes-fijos-enum';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { DecimalPipe, NgFor, NgIf } from '@angular/common';
import { rechazoDelGuardado } from '../../resolucion-version.util';

/** Un id de cos_version (numérico): el único que resuelve consultaVersion.do (docs/DEFECTOS.md §1). */
const ID_NUMERICO = /^\d+$/;

@Component({
    selector: 'app-comentarios',
    standalone: true,
    templateUrl: './comentarios.component.html',
    styleUrls: ['./comentarios.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelectionList, NgFor, NgIf, DecimalPipe, MatListOption, MatButton]
})
export class ComentariosComponent implements OnInit {

  formRegistro: FormGroup;
  bean: Incidencias = new Incidencias();
  status: string;
  version: string;
  listaversion: Array<VersionBean>;
  descripcion: string;
  selectedVersion: string;
  tituloVersion: string;
  totalsize = 0;
  evidencia = [];
  selectedOptions = [];
  index: number;
  btnElimina: boolean = true;
  btnAgrega: boolean = false;
  esCometario: boolean = false;


  constructor(public dialogRef: MatDialogRef<ComentariosComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private incidenciasService: IncidenciasService, private formBuilder: FormBuilder) { }

  ngOnInit() {
    switch (this.data.titulo) {
      case 'Agregar comentario': {
        this.status = this.data.dataKey.estatus;
        this.esCometario = true;
        break;
      }
      case 'Cancelar': {
        this.status = Constantes.CANCELADO;
        break;
      }
      case 'En Revision': {
        this.status = Constantes.REVISION;
        break;
      }
      case 'Observacion': {
        this.status = Constantes.OBSERVACIONES;
        break;
      }
      case 'VoBo': {
        this.status = Constantes.VOBO;
      }
    }

    this.consultaVersion();
    this.formreg();
  }

  consultaVersion() {
    // El detalle ya trae el nombre de la etapa del proyecto: consultaVersion.do
    // espera un número y no resuelve los ids de Mongo.
    if (this.data.nombreVersion) {
      this.tituloVersion = this.data.nombreVersion;
      return;
    }
    // Un UUID de Mongo (o el centinela de T3b) no lo resuelve consultaVersion.do.
    if (!ID_NUMERICO.test(String(this.data.version ?? ''))) {
      return;
    }
    this.incidenciasService.searchVersion(this.data.version).subscribe(res => {
      this.tituloVersion = res?.nombre;
    });
  }

  onSave() {
    if (this.formRegistro.valid) {
      this.bean.descincidencia = this.formRegistro.value.descripcion;
      this.bean.id_version_incidencia = this.data.version;
      this.bean.estatus = this.status;
      this.bean.id = this.data.dataKey.id
      this.bean.id_proyecto = this.data.dataKey.id_proyecto;
      this.bean.fecha_creacion = this.data.dataKey.fecha_creacion;
      this.bean.id_incidencia_proyecto = this.data.dataKey.id_incidencia_proyecto;
      this.bean.id_usuario_qa = this.data.dataKey.id_usuario_qa;

      if (this.esCometario) {
        this.bean.esComentario = Constantes.UNO;
      } else {
           this.bean.esComentario = Constantes.CERO;
      }
      this.incidenciasService.guardaComentario(this.bean).subscribe(incidencia => {
        // Un rechazo (VAL-*, p. ej. la revisión de una resolución que espera
        // versión) o una respuesta vacía no se pintan como éxito.
        const rechazo = rechazoDelGuardado(incidencia);
        if (rechazo) {
          swal.fire({
            text: rechazo,
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-danger',
            },
            icon: 'error',
          });
          return;
        }
        if (this.evidencia.length > 0) {
          const formData = new FormData();
          for (let i = 0; i < this.evidencia.length; i++) {
            formData.append('file', this.evidencia[i], "INCIDENCIA" + "$" + "QA" + "$" + incidencia.id + "$" + incidencia.detalleBean.id + "$" + incidencia.id_proyecto + "$" + this.evidencia[i].name);
          }
          this.incidenciasService.uploadEvidencia(formData).subscribe();
        }
        swal.fire({
          text: MensajesFijosEnum.INCIDENCIA_EXITOSA,
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success',
          },
          icon: 'success',
    
        }).then(() => {
          this.dialogRef.close(incidencia as Incidencias);
        });
      });
    }
    else {
      swal.fire({
        text: MensajesFijosEnum.INCIDENCIA_DATOS_VACIOS,
        buttonsStyling: false,
        customClass:{
          confirmButton: 'btn btn-danger',
        },
        icon: 'error'
      })
    }
  }

  formreg() {
    this.formRegistro = this.formBuilder.group({
      descripcion: ['', [Validators.required]],
      evidenciaSeleccionada: [[]]
    });
  }

  subirEv() {
    const input = (<HTMLInputElement>document.getElementById('nameFile'));
    if (input.files.length > 0) {
      for (let i = 0; i <= input.files.length - 1; i++) {
        this.totalsize = this.totalsize + input.files.item(i).size;
        this.evidencia.push(input.files[i])
      }
    }
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";
  }

  onNgModelChange($event) {
    this.selectedOptions = $event;
    if (this.selectedOptions.length != 0) {
      this.btnElimina = false;
      this.btnAgrega = true;
    } else {
      this.btnElimina = true;
      this.btnAgrega = false;
    }
  }

  onEvidenciaChange(): void {
    const seleccionados = this.formRegistro.get('evidenciaSeleccionada')?.value || [];
  
    this.selectedOptions = seleccionados;
  
    this.btnElimina = seleccionados.length === 0;
    this.btnAgrega = !this.btnElimina;
  }
  


  elimina() {
    for (let i = 0; i < this.selectedOptions.length; ++i) {
      this.index = this.evidencia.findIndex(item => item.name === this.selectedOptions[i].name);
      if (this.index >= 0) {
        this.evidencia.splice(this.index, 1);
      }
    }
    
    this.formRegistro.get('evidenciaSeleccionada')?.setValue([]);
  
    this.selectedOptions = [];
    this.btnElimina = true;
    this.btnAgrega = false;
  
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";
  }
  

  onCloseClick() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
